var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Api } from '@app/Api';
var LockStore = /** @class */ (function () {
    function LockStore() {
        this._current = null;
        this._next = null;
    }
    LockStore.prototype.setNext = function (store) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._next) {
                            this._next.hideLoading();
                        }
                        this._next = store;
                        this._next.showLoading();
                        return [4 /*yield*/, this._processNextItem()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LockStore.prototype._processNextItem = function () {
        return __awaiter(this, void 0, void 0, function () {
            var objectUniqueId, section, lock, lockModel, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._current || !this._next)
                            return [2 /*return*/];
                        this._current = this._next;
                        this._next = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 9]);
                        this._current.showLoading();
                        objectUniqueId = this._current.getObjectUniqueId();
                        section = this._current.getSection();
                        lock = { objectUniqueId: objectUniqueId, section: section };
                        return [4 /*yield*/, Api.secured.createLock({ body: lock })];
                    case 2:
                        lockModel = _a.sent();
                        if (!this._next) return [3 /*break*/, 4];
                        return [4 /*yield*/, Api.secured.unLock(lock)];
                    case 3:
                        _a.sent();
                        this._current.setLockModel(null);
                        return [3 /*break*/, 5];
                    case 4:
                        this._current.setLockModel(lockModel);
                        _a.label = 5;
                    case 5: return [3 /*break*/, 9];
                    case 6:
                        e_1 = _a.sent();
                        console.log('STORE: Failed to lock the cell');
                        console.log(e_1);
                        this._current.setLockModel(null);
                        return [3 /*break*/, 9];
                    case 7:
                        this._current.hideLoading();
                        this._current = null;
                        return [4 /*yield*/, this._processNextItem()];
                    case 8:
                        _a.sent();
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    return LockStore;
}());
export var lockStore = new LockStore();
